import PeriodPicker from 'components/PeriodPicker';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import { useExportAuditLogs } from './useExportAuditLogs';
import { Tooltip } from '@material-ui/core';
import {
  LBButton,
  LBLabel,
  LBSelect,
  LBSelectContent,
  LBSelectGroup,
  LBSelectItem,
  LBSelectTrigger,
  LBSelectValue
} from '@linearb/buzz';

export const AUDIT_FORMAT_TYPES = {
  CSV: 'csv',
  JSON: 'json'
};

const formatOptions = [
  { value: AUDIT_FORMAT_TYPES.CSV, displayValue: '.CSV' },
  { value: AUDIT_FORMAT_TYPES.JSON, displayValue: '.JSON' }
];

export const ExportAuditLogs = ({ selectedTeam, isTeamSettings }) => {
  const teamId = selectedTeam?.id || null;

  const {
    period,
    setPeriod,
    exportAuditLogs,
    formatType,
    setFormatType,
    isSaveEnabled,
    isPeriodLongerThanOneYear
  } = useExportAuditLogs({ teamId, isTeamSettings });
  return (
    <>
      <div className='flex flex-col gap-2'>
        <h3 className='text-lg pb-2'>Audit log</h3>
        <div className='flex items-center gap-2'>
          <LBLabel>Date range for this log</LBLabel>
          {/* @ts-expect-error */}
          <PeriodPicker
            currentPeriod={period}
            onChange={period => {
              setPeriod({
                ...PERIODS[period.selectedPeriodKey],
                before: period.end_date,
                after: period.start_date
              });
            }}
            size='large'
            width='20rem'
            showCalendarIcon={true}
            hiddenPeriods={[PERIODS.ITERATIONS.periodKey]}
          />
        </div>
        <div className='flex items-center gap-2'>
          <LBLabel>File format for this log</LBLabel>

          <LBSelect value={formatType} onValueChange={setFormatType}>
            <LBSelectTrigger>
              <LBSelectValue />
            </LBSelectTrigger>
            <LBSelectContent>
              <LBSelectGroup>
                {formatOptions.map(option => (
                  <LBSelectItem value={option.value} key={option.value}>
                    {option.displayValue}
                  </LBSelectItem>
                ))}
              </LBSelectGroup>
            </LBSelectContent>
          </LBSelect>
        </div>
      </div>
      <aside>
        <Tooltip
          title='Select shorter period than a year'
          disableHoverListener={!isPeriodLongerThanOneYear}
        >
          <span>
            <LBButton
              size='lg'
              variant='outline'
              disabled={!isSaveEnabled}
              onClick={exportAuditLogs}
            >
              Download log
            </LBButton>
          </span>
        </Tooltip>
      </aside>
    </>
  );
};
